<template>
<div>
   <div class="title">
    <span class="link">需求管理 ></span> <span class="curLink">我的需求</span>
   </div>
   <div class="content">
     <div class="pageList">
         <div class="list">
           <template v-if="content.length">
             <div class="listItem" v-for="(item, index) in content" :key="index">
                <div class="btn" @click="doDelete(item)">
                  <div>
                    <img class="delIcon" src="../../assets/images/lajitong.png" />
                    <span>删除</span>
                  </div>
                <!-- <img src="../../assets/images/rightArrow.png" alt=""> -->
                </div>
                <div class="name">
                  <span>{{item.name}}</span>
                  <span class="status" :style="item.status|statusColor">{{ item.status | setStatus}}</span>
                </div>
                <div class="oneRow">
                  <div>
                    <span class="test">服务行业</span>
                    <span>{{item.categoryName}}</span>
                  </div>
                  <div>
                    <span class="test">联系人</span>
                    <span>{{item.contacts}}</span>
                  </div>
                  <div>
                    <span class="test">联系电话</span>
                    <span>{{item.phone}}</span>
                  </div>
                </div>
                <div class="pageContent">
                  <div class="left">
                    <div class="twoRow">
                      <div>
                        <span class="test">企业名称</span>
                        <span>{{item.enterpriseName}}</span>
                      </div>
                      <div>
                        <span class="test">预算</span>
                        <span>{{item.budget}}</span>
                      </div>
                      <div>
                        <span class="test">发布时间</span>
                        <span>{{item.createTime}}</span>
                      </div>
                    </div>
                    <div class="twoRow">
                      <div>
                        <span class="test">需求详情</span>
                        <span style="width: 90%;box-sizing: border-box;padding: 0 5px">{{item.details}}</span>
                      </div>
                      <template v-if="item.status == 1">
                        <div>
                          <span class="test">审核备注</span>
                          <span>{{item.reason}}</span>
                        </div>
                        <div>
                          <span class="test">审核时间</span>
                          <span>{{item.approveTime}}</span>
                        </div>
                      </template>

                    </div>

                  </div>
                </div>

                <!--新加的评论 start-->
                <div class="commentlist">
                  <div class="clearfix">
                    <div class="lookBtn" @click="handleLook(index, item.commentSwitch, item.id)">
                      <img src="../../assets/images/icon_pl@2x.png" />
                      <span>
                        <!-- {{index}}---{{item.commentSwitch}} -->
                        <template v-if="item.commentSwitch">收起评论</template>
                        <template v-else>查看评论 <span class="plNum">{{ item.messageNum}}</span></template>
                      </span>
                    </div>
                  </div>
                  <div class="commentBox" v-show="item.commentSwitch">
                    <template v-if="item.commentData.length">
                      <div class="commentItem" v-for="(cItem, cIndex) in item.commentData" :key="cIndex">
                          <div>
                            <img :src="cItem.userLogo ? baseUrl + cItem.userLogo : require('../../assets/images/-s-mrtx.png')" class="avatar" /><span class="nickName">{{cItem.username}}</span>
                            <span class="commTime">{{cItem.createTime}}</span>
                          </div>
                          <div class="plText">
                            <span>评论：</span>
                            {{ cItem.message}}
                          </div>
                      </div>
                    </template>
                    <div v-else class="noData">暂无数据
                      <!-- ，快去<span @click="goDetail(item.id)">评论</span>吧！ -->
                    </div>
                  </div>
                </div>
              <!--新加的评论 end-->
            </div>
           </template>
           <template v-else>
              <Nodata />
           </template>

         </div>
         <div class="pageBox">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNum"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next"
              :total="total">
            </el-pagination>
          </div>
     </div>
   </div>
</div>
</template>
<script>
  import {
    serverUrl
  } from '@/utils/server.js'
  import {
    UserSupplyDemandList,
    reserveMessageList,
    fetchDelSupplyDemand
  } from '@/api/api'
  import Nodata from '@/components/noData.vue'
  export default {
    data() {
      return {
        pageNum: 0,
        pageSize: 10,
        loading: false,
        total: 0,
        content: [
        ],
        baseUrl: serverUrl.baseURL,
      }
    },
    components: {
      Nodata
    },
    mounted() {
      this.getUserSupplyDemandList()
    },
    filters: {
      setStatus: function(type) {
        const statusList = {
          0: '待审核',
          1: '通过',
          2: '不通过'
        }
        return statusList[type]
      },
      statusColor: function(val) {
        let color = ""
        let background = ""
        if (val == 1) {
          color = "#29C87E"
          background = '#E1FAEF'
        } else if (val == 0) {
          color = "#225EFD"
          background = '#E6EFFF'
        } else if (val == 2) {
          color = "#FF8D3A"
          background = '#FFEFE5'
        }
        return 'color: ' + color + ';' + 'background: ' + background + ';' + 'border: 1px solid' + color
      },
    },
    methods: {
      doDelete(item) {
        let params = {
          id: item.id
        }
        fetchDelSupplyDemand(params).then(res => {
          if(res.code === 1) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getUserSupplyDemandList()
          }
        })
      },
      goDetail(id) {
        this.$router.push({
          path: '/DiscussDetails',
          query: {
            data: id
          },
        })
      },
      // 查看评论
      handleLook(index, commentSwitch, id) {
        let data = []
        if(!commentSwitch) {
          this.getCommentList(id, index)
        }
        this.content[index].commentSwitch = !commentSwitch
        // this.content[index].commentData = data
      },
      // 获取评论数据
      getCommentList(id,index) {
        let params={
          pageNum: 0,
          pageSize: 1000,
          supplyDemandId: id
        }
       reserveMessageList(params).then(res => {
        this.content[index].commentData = res.data.content
       })
      },
      //当前页变更
      handleCurrentChange(num) {
        this.pageNum = num
        this.getUserSupplyDemandList();
      },
      //当前页查询数据条数变更
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.getUserSupplyDemandList();
      },
      getUserSupplyDemandList() {
        let params = {
          page: this.pageNum >= 1 ? this.pageNum - 1 : this.pageNum,
          size: this.pageSize,
          type: 1,
        }
        UserSupplyDemandList(params).then(res => {
          this.content = res.data.content.map(item => {
            return {
              ...item,
              commentSwitch: false,
              commentData: []
            }
          })
          this.total = Number(res.data.totalElements)
        })
      }
    }
  }
</script>
<style scoped>
.title {
    height: 66px;
    line-height: 66px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #282F3D;
    padding-left: 30px;
    background: #fff;
  }
  .curLink{
    cursor: pointer;
  }
  .link{
    color: rgba(144, 157, 177, 1);
  }
  .content {
    box-sizing: border-box;
    padding: 10px 20px;
  }

  .pageList {
    width: 100%;
    height: calc(100vh - 180px);
    background: #FFFFFF;
    box-shadow: 1px 3px 16px 0px rgba(204, 211, 228, 0.51);
    border-radius: 8px;
    box-sizing: border-box;
    padding: 20px 40px;
  }
  .list{
    height: calc(100vh - 280px);
    overflow-y: scroll;
  }
  .list::-webkit-scrollbar { width: 0 !important }
  .pageBox{
    display: flex;
    justify-content: flex-end;
  }
  .listItem {
    border-bottom: 1px solid #E8EBF4;
    padding: 5px 20px 0;
    position: relative;
  }
  .name {
    padding: 15px 0;
  }
  .pageContent {
    /* display: flex;
    justify-content: space-between;
    align-items: center; */
    position: relative;
  }

  .infoContent {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #516381;
    line-height: 28px;
  }

  .oneRow,
  .twoRow {
    display: flex;
    justify-content: flex-start;
  }

  .oneRow>div,
  .twoRow>div {
    padding: 10px 0;
    width: 30%;
    display: flex;
  }

  .threeRow {
    padding: 10px 0;
  }

  .categoryName {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
  }

  .test {
    display: inline-block;
    width: 80px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #909DB1;
  }

  .status {
    /* background: rgba(34,94,253,0.2); */
    /* border: 1px solid #225EFD; */
    border-radius: 22px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #225EFD;
    text-align: center;
    padding: 5px 10px;
    margin-left: 10px;
  }

  .btn {
    width: 100px;
    height: 43px;
    /* border: 1px solid #0F5EFF; */
    border-radius: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: -10px;
    top: 0px;
    cursor: pointer;
    color: #515151;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
  }
  .btn .delIcon{
    width: 16px;
    vertical-align: middle;
    margin-right: 5px;
  }
  .btn span{
    vertical-align: middle;
  }

  .commentlist .commentBox{
    border-top: 1px solid #9DB8EF;
    background: #F4F5F9;
    padding-top: 25px;
    max-height: 556px;
    overflow-y: scroll;
  }
  .commentItem{
    padding: 0 23px 30px;
    /* display: flex;
    align-items: center;
    justify-content: space-between; */
  }
  .commentItem .avatar{
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 13px;
  }
  .commentItem .nickName{
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
  }
  .plText{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
    padding-top: 20px;
  }
  .plText span {
    color: #225EFD;
  }
  .lookBtn{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #0F5EFF;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 1px solid #0F5EFF;
    border-radius: 21px;
    display: inline-block;
    padding: 5px 10px;
    float: right;
    margin-bottom: 10px;
  }
  .lookBtn img {
    width: 18px;
    height: 18px;
    display: inline-block;
    position: relative;
    top: 2px;
  }
  .commTime{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #516381;
    float: right;
  }
  .clearfix::after {
    content: "";
    display: block;
    visibility: hidden;
    clear: both;
  }

.noData{
  text-align: center;
  padding: 50px 0;
}
.noData span{
  color: #0F5EFF;
  cursor: pointer;
}
.plNum{
  color: #0F5EFF;
}
</style>



// WEBPACK FOOTER //
// src/views/console/MyDemand.vue